export type UiActionSnapshot={owner:string;equipment:Readonly<Record<string,string|null>>;potions:number};
type PendingAction={action:'equip'|'unequip'|'potion';value:string;before:UiActionSnapshot;startedAt:number};

/** Acknowledgement by relevant authority change, never by an unrelated refresh. */
export class UiActionGate{
 private pending:PendingAction|undefined;
 get busy():boolean{return !!this.pending;}
 begin(action:'equip'|'unequip'|'potion',value:string,before:UiActionSnapshot,now:number):boolean{
  if(this.pending||action==='equip'&&Object.values(before.equipment).includes(value)||action==='unequip'&&(!value||before.equipment.charm!==value)||action==='potion'&&before.potions<=0)return false;
  this.pending={action,value,before:{...before,equipment:{...before.equipment}},startedAt:now};return true;
 }
 observe(after:UiActionSnapshot):boolean{
  const p=this.pending;if(!p)return false;
  if(after.owner!==p.before.owner||p.action==='equip'&&Object.values(after.equipment).includes(p.value)||p.action==='unequip'&&after.equipment.charm===''||p.action==='potion'&&after.potions<p.before.potions){this.clear();return true;}
  return false;
 }
 clear():boolean{const was=!!this.pending;this.pending=undefined;return was;}
}
// One pending equip/use per browser session, including scene UI recreation.
export const uiActionGate=new UiActionGate();
